import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { requerido } from './Validaciones'

import { cookieData } from '../funciones/ConsultaUser';

export const ConsultPaices = (respuesta) => {
    Post(`${Url}consultPaices`, "", (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            contenido.push(
                { id: data[i].id, nombre: data[i].pais_name }
            )
        }

        respuesta(contenido)
    });
}

export const Guardar = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.nombre.text, "", "", "", "El Nombre del País Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1]
            }

            Post(`${Url}addPais`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha guardado correctamente el país"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const verPais = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }

        Post(`${Url}verPais`, Content, (resp) => {
            let data = JSON.parse(resp)
            let state = {
                cantErrores: "",
                nombre:  { text: data[0].pais_name, status: "" },
                preloaderMess:{ icon: "", text: "" },
                boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
                boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
                boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
            }

            respuesta (state) 
        });
    });
}

export const Editar = (id, campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo modificar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.nombre.text, "", "", "", "El Nombre del País Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1],
                id: id
            }

            Post(`${Url}editPais`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo modificar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha guardado correctamente el país"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const Delete = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }
        Post(`${Url}delPais`, Content, (resp) => {
            respuesta (resp)
        });
    });
}

export const ConsultaPaices = (respuesta) => {
    Post(`${Url}consultPaices`, "", (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            contenido.push(
                { value: data[i].id, label: data[i].pais_name }
            )
        }
        respuesta(contenido)
    });
}

export const FuncionTmp = () => {
    Post(`${Url}funciontmp`, "", (resp) => {
        let data1 = JSON.parse(resp);
        console.log(data1)
    });
}

/* ---------------------------------------------- ESTADOS ------------------------------------------------- */

export const ConsultaEstados = (id, respuesta) => {
    let Content = {
        id: id,
    }

    Post(`${Url}consultEstados`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            if (data[i].estado_name !== "Default") contenido.push(
                { id: data[i].id, nombre: data[i].estado_name }
            )
        }

        respuesta(contenido)
    });
}

export const verEstado = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }

        Post(`${Url}verEstado`, Content, (resp) => {
            let data = JSON.parse(resp)
            let state = {
                cantErrores: "",
                nombre:  { text: data[0].estado_name, status: "" },
                preloaderMess:{ icon: "", text: "" },
                boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
                boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
                boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
            }

            respuesta (state) 
        });
    });
}

export const GuardarEstado = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorPais.value, "", "", "", "Debes seleccionar primero un País de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre del Estado Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1]
            }

            Post(`${Url}addEstado`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha guardado correctamente el estado"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const EditarEstado = (id, campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorPais.value, "", "", "", "Debes seleccionar primero un País de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre del Estado Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1],
                id: id
            }

            Post(`${Url}editEstado`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo modificar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha modificado correctamente el estado"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const DeleteEstado = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }
        Post(`${Url}delEstado`, Content, (resp) => {
            respuesta (resp)
        });
    });
}

/* ---------------------------------------- CIUDADES ----------------------------------------- */
export const ConsultaEstadosSelect = (id, respuesta) => {
    let Content = {
        id: id,
    }

    Post(`${Url}consultEstados`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            if (data[i].estado_name !== "Default") contenido.push(
                { value: data[i].id, label: data[i].estado_name }
            )
        }

        respuesta(contenido)
    });
}

export const ConsultaCiudades = (id, respuesta) => {
    let Content = {
        id: id,
    }

    Post(`${Url}consultCiudades`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            if (data[i].ciudad_name !== "Default") contenido.push(
                { id: data[i].id, nombre: data[i].ciudad_name }
            )
        }

        respuesta(contenido)
    });
}

export const GuardarCiudad = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorPais.value, "", "", "", "Debes seleccionar un País de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorEstado.value, "", "", "", "Debes seleccionar un Estado de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre de la Ciudad Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1]
            }

            Post(`${Url}addCiudad`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha guardado correctamente la ciudad"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const verCiudad = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }

        Post(`${Url}verCiudad`, Content, (resp) => {
            let data = JSON.parse(resp)
            let state = {
                cantErrores: "",
                nombre:  { text: data[0].ciudad_name, status: "" },
                preloaderMess:{ icon: "", text: "" },
                boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
                boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
                boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
            }

            respuesta (state) 
        });
    });
}

export const EditarCiudad = (id, campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo modificar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorPais.value, "", "", "", "Debes seleccionar un País de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorEstado.value, "", "", "", "Debes seleccionar un Estado de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre de la Ciudad Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1],
                id:id
            }

            Post(`${Url}editCiudad`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo modificar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha modificado correctamente la ciudad"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const DeleteCiudad = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }
        Post(`${Url}delCiudad`, Content, (resp) => {
            respuesta (resp)
        });
    });
}

/* ---------------------------------- MUNICIPIOS -------------------------------------------- */

export const ConsultaMunicipios = (id, respuesta) => {
    let Content = {
        id: id,
    }

    Post(`${Url}consultMunicipios`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            if (data[i].municipio_name !== "Default") contenido.push(
                { id: data[i].id, nombre: data[i].municipio_name }
            )
        }

        respuesta(contenido)
    });
}

export const GuardarMunicipio = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorPais.value, "", "", "", "Debes seleccionar un País de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorEstado.value, "", "", "", "Debes seleccionar un Estado de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre del Municipio Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1]
            }

            Post(`${Url}addMunicipio`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha guardado correctamente el municipio"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const verMunicipio = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }

        Post(`${Url}verMunicipio`, Content, (resp) => {
            let data = JSON.parse(resp)
            let state = {
                cantErrores: "",
                nombre:  { text: data[0].municipio_name, status: "" },
                preloaderMess:{ icon: "", text: "" },
                boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
                boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
                boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
            }

            respuesta (state) 
        });
    });
}

export const EditarMunicipio = (id, campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo modificar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorPais.value, "", "", "", "Debes seleccionar un País de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorEstado.value, "", "", "", "Debes seleccionar un Estado de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre del Municipio Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1],
                id:id
            }

            Post(`${Url}editMunicipio`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo modificar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha modificado correctamente el municipio"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const DeleteMunicipio = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }
        Post(`${Url}delMunicipio`, Content, (resp) => {
            respuesta (resp)
        });
    });
}

/* -------------------------------------- PARROQUIAS ------------------------------------------- */
export const ConsultaMunicipiosSelect = (id, respuesta) => {
    let Content = {
        id: id,
    }

    Post(`${Url}consultMunicipios`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            if (data[i].municipio_name !== "Default") contenido.push(
                { value: data[i].id, label: data[i].municipio_name }
            )
        }

        respuesta(contenido)
    });
}

export const ConsultaParroquias = (id, respuesta) => {
    let Content = {
        id: id,
    }

    Post(`${Url}consultParroquias`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            if (data[i].parroquia_name !== "Default") contenido.push(
                { id: data[i].id, nombre: data[i].parroquia_name }
            )
        }

        respuesta(contenido)
    });
}

export const verParroquia = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }

        Post(`${Url}verParroquia`, Content, (resp) => {
            let data = JSON.parse(resp)
            let state = {
                cantErrores: "",
                nombre:  { text: data[0].parroquia_name, status: "" },
                preloaderMess:{ icon: "", text: "" },
                boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
                boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
                boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
            }

            respuesta (state) 
        });
    });
}

export const GuardarParroquia = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorPais.value, "", "", "", "Debes seleccionar un País de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorEstado.value, "", "", "", "Debes seleccionar un Estado de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });
    
    requerido(errores, campos.valorMunicipio.value, "", "", "", "Debes seleccionar un Municipio de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre de la Parroquia Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1]
            }

            Post(`${Url}addParroquia`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha guardado correctamente la parroquia"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const EditarParroquia = (id, campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorPais.value, "", "", "", "Debes seleccionar un País de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorEstado.value, "", "", "", "Debes seleccionar un Estado de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });
    
    requerido(errores, campos.valorMunicipio.value, "", "", "", "Debes seleccionar un Municipio de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre de la Parroquia Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                usu: cookie[1],
                id:id
            }

            Post(`${Url}editParroquia`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo modificar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha modificado correctamente la parroquia"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const DeleteParroquia = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            usu: cookie[1]
        }
        Post(`${Url}delParroquia`, Content, (resp) => {
            respuesta (resp)
        });
    });
}


// WEBPACK FOOTER //
// ./src/funciones/EntidadesFuncion.jsx